/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Search_TitleInputs */

const en_pc_tut_search_title = /** @type {(inputs: Pc_Tut_Search_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search inside a document`)
};

const zh_pc_tut_search_title = /** @type {(inputs: Pc_Tut_Search_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在文档中搜索`)
};

/**
* | output |
* | --- |
* | "Search inside a document" |
*
* @param {Pc_Tut_Search_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_search_title = /** @type {((inputs?: Pc_Tut_Search_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Search_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_search_title(inputs)
	return zh_pc_tut_search_title(inputs)
});
export { pc_tut_search_title as "pc.tut.search.title" }